import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

// Create projectStatus API
const projectStatusAPI = createApi({
    reducerPath: "projectStatusAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) =>({
        // projectStatus Endpoints

        addProjectDefaultStatus: builder.mutation({
            query: (data) => ({
                url: `/ProjectStatusConfiguration/AddProjectDefaultStatus`,
                method: 'POST',
                body: transformRequest(data),
            }),
            // invalidateTags: ['addProjectStatus'],
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        
        // Query to get all project Status list
        getAllProjectStatusList: builder.query({
            query: () => ({
                url: `/ProjectStatusConfiguration/GetAllProjectStatusList`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        //Add ProjectStatus
        addProjectStatus: builder.mutation({
            query: (data) => ({
                url: `/ProjectStatusConfiguration/AddProjectStatus`,
                method: 'POST',
                body: transformRequest(data),
            }),
            // invalidateTags: ['addProjectStatus'],
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // Query to get project Status by Id
        getProjectStatusByID: builder.query({
            query: (projectStatusConfigurationId) => ({
                url: `/ProjectStatusConfiguration/GetProjectStatusByID?projectStatusConfigurationId=${Number(projectStatusConfigurationId)}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // Update project Status
        updateProjectStatusByID: builder.mutation({
            query: (projectStatusDetails) => ({
                url: '/ProjectStatusConfiguration/UpdateProjectStatusByID',
                method: 'POST',
                body: transformRequest(projectStatusDetails)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // Delete project Status
        deleteProjectStatus: builder.mutation({
            query: (details) => ({
                url: `/ProjectStatusConfiguration/DeleteProjectStatus?projectStatusConfigurationId=${details}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        //Get All project Status list with pagination
        getProjectStatusWithPagination: builder.mutation({
            query: (projectStatusQuery) => ({
                url: `/ProjectStatusConfiguration/GetProjectStatusWithPagination`,
                method: 'POST',
                body: transformRequest(projectStatusQuery)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateOrderProjectStatusConfiguration: builder.mutation({
            query: (projectStatus) => ({
                url: `/ProjectStatusConfiguration/UpdateOrderProjectStatusConfiguration`,
                method: 'POST',
                body: transformRequest(projectStatus)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getProjectStatusbyStatusCategoryId:builder.query({
            query:(projectId,statusCategoryId)=>({
                url:`/ProjectStatusConfiguration/GetProjectStatusbyStatusCategoryId?ProjectId=${projectId}&StatusCategoryId=${statusCategoryId}`,
                method:'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        })
    })
})

// Extract hooks for easy access to various API requests 
export const{
    useAddProjectDefaultStatusMutation,
    useLazyGetAllProjectStatusListQuery,
    useAddProjectStatusMutation,
    useLazyGetProjectStatusByIDQuery,
    useUpdateProjectStatusByIDMutation,
    useDeleteProjectStatusMutation,
    useGetProjectStatusWithPaginationMutation,
    useUpdateOrderProjectStatusConfigurationMutation,
    useLazyGetProjectStatusbyStatusCategoryIdQuery
} = projectStatusAPI;

export default projectStatusAPI;